import React from "react";
import { Checkbox } from "antd";
import styles from "../../JobShiftPreStart/JobShiftPreStartView.module.css";

const getResponseConfig = (question = {}) => (
  question && question.response_config && typeof question.response_config === "object"
    ? question.response_config
    : {}
);

function ReadOnlyRadioOptions({ options = [] }) {
  if (!options.length) return null;

  return (
    <div className={styles.PreStartOptionList}>
      {options.map((option, index) => {
        const value = option && option.value !== undefined && option.value !== null ? `${option.value}` : "";
        const label = option && option.label ? option.label : value;
        const optionClass = ["yes", "pass"].includes(value)
          ? styles.PreStartOptionItemPositive
          : ["no", "fail", "not_applicable"].includes(value)
            ? styles.PreStartOptionItemNegative
            : "";

        return (
          <Checkbox
            checked={false}
            onChange={() => {}}
            className={`${styles.PreStartOptionItem} ${optionClass}`.trim()}
            key={`${value}-${index}`}
          >
            {label}
          </Checkbox>
        );
      })}
    </div>
  );
}

function ReadOnlyEmptyNumberField({ unit }) {
  return (
    <div className={styles.PreStartEditableNumberWrap}>
      <div className={styles.PreStartEditableNumberControl}>
        <div>
          <div>
            <div className="position-relative">
              <input
                type="number"
                value=""
                readOnly
                className={`${styles.PreStartEditableInput} ${styles.PreStartEditableNumberInput}`}
              />
            </div>
          </div>
        </div>
      </div>
      {unit ? <span className={styles.PreStartEditableUnit}>{unit}</span> : null}
    </div>
  );
}

function ReadOnlyEmptyTextField() {
  return (
    <div className={styles.PreStartEditableTextareaWrap}>
      <div className={styles.PreStartEditableTextarea} aria-hidden="true" />
    </div>
  );
}

function ReadOnlyEmptySignature() {
  return <span className={styles.PreviewValue}>—</span>;
}

function ReadOnlyEmptyPhotoField() {
  return (
    <div className={styles.PreStartAttachmentActionRow}>
      <div className={styles.PreStartAttachmentButtonGroup}>
        <button type="button" className={styles.PreStartAttachmentPill} onClick={(event) => event.preventDefault()}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" height="14px" width="14px" aria-hidden="true">
            <path fill="currentColor" d="M352 173.3L352 384C352 401.7 337.7 416 320 416C302.3 416 288 401.7 288 384L288 173.3L246.6 214.7C234.1 227.2 213.8 227.2 201.3 214.7C188.8 202.2 188.8 181.9 201.3 169.4L297.3 73.4C309.8 60.9 330.1 60.9 342.6 73.4L438.6 169.4C451.1 181.9 451.1 202.2 438.6 214.7C426.1 227.2 405.8 227.2 393.3 214.7L352 173.3zM320 464C364.2 464 400 428.2 400 384L480 384C515.3 384 544 412.7 544 448L544 480C544 515.3 515.3 544 480 544L160 544C124.7 544 96 515.3 96 480L96 448C96 412.7 124.7 384 160 384L240 384C240 428.2 275.8 464 320 464zM464 488C477.3 488 488 477.3 488 464C488 450.7 477.3 440 464 440C450.7 440 440 450.7 440 464C440 477.3 450.7 488 464 488z" />
          </svg>
          Upload Photo
        </button>
      </div>
    </div>
  );
}

function ReadOnlyResponse({ responseConfig }) {
  switch (responseConfig.type) {
    case "radio":
      return <ReadOnlyRadioOptions options={responseConfig.options} />;
    case "number": {
      const unit = typeof responseConfig.unit === "string" ? responseConfig.unit.trim() : "";
      return <ReadOnlyEmptyNumberField unit={unit} />;
    }
    case "text":
      return <ReadOnlyEmptyTextField />;
    case "signature":
      return <ReadOnlyEmptySignature />;
    case "photo":
      return <ReadOnlyEmptyPhotoField />;
    default:
      return null;
  }
}

export default function PreStartQuestionPreview({ question, number }) {
  const questionConfig = question || {};
  const responseConfig = getResponseConfig(questionConfig);
  const isWorkerScope = questionConfig.answer_scope === "worker";
  const questionText = questionConfig.question_text || "";
  const guidanceText = questionConfig.guidance_text || "";

  return (
    <tr>
      <td className={styles.PreStartQuestionNumber}>{number}</td>
      <td className={styles.PreStartQuestionTextCell} colSpan={2}>
        <div className={styles.PreStartQuestionTextLine}>
          <span>{questionText}</span>
          {isWorkerScope ? <span className={styles.PreStartQuestionScope}>Per-Worker</span> : null}
        </div>
        {guidanceText ? <div className={styles.PreStartQuestionGuidance}>{guidanceText}</div> : null}
      </td>
      <td className={styles.PreStartQuestionAnswerCell}>
        {isWorkerScope ? (
          <div className={styles.PreStartAnswerStack}>
            <div className={styles.PreStartAnswerRow}>
              <div className={styles.PreStartAnswerContent}>
                <div className={styles.PreStartAnswerBox}>
                  <ReadOnlyResponse responseConfig={responseConfig} />
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className={styles.PreStartAnswerRow}>
            <div className={styles.PreStartAnswerContent}>
              <div className={styles.PreStartAnswerBox}>
                <ReadOnlyResponse responseConfig={responseConfig} />
              </div>
            </div>
          </div>
        )}
      </td>
    </tr>
  );
}
